"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_responsive_1 = require("react-responsive");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class HoverTextInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isHovered: false,
        };
        this.handleHover = this.handleHover.bind(this);
    }
    handleHover(isHovered) {
        if (window.innerWidth >= 1140) {
            this.setState({
                isHovered,
            });
        }
    }
    componentDidUpdate() {
        const { field } = this.props;
        const triangleChild = document.getElementById(`hoverTextInputTriangle_${field}`);
        const descriptionChild = document.getElementById(`hoverTextInputDescriptionChild_${field}`);
        const parent = document.getElementById(`hoverTextInputParent_${field}`);
        const bridgeHover = document.getElementById(`hoverTextBridge_${field}`);
        if (descriptionChild && triangleChild && parent && bridgeHover) {
            triangleChild.style.top = `${parent.getBoundingClientRect().top -
                (triangleChild.getBoundingClientRect().height - parent.getBoundingClientRect().height) / 2}px`;
            descriptionChild.style.top = `${parent.getBoundingClientRect().top -
                (descriptionChild.getBoundingClientRect().height - parent.getBoundingClientRect().height) / 2}px`;
            bridgeHover.style.top = `${parent.getBoundingClientRect().top}px`;
            bridgeHover.style.height = `${parent.getBoundingClientRect().height}px`;
        }
    }
    render() {
        const { children, description, field } = this.props;
        const { isHovered } = this.state;
        const style = isHovered
            ? {
                marginLeft: -32,
                marginRight: -32,
                paddingRight: 32,
                paddingLeft: 32,
                background: src_1.beige,
            }
            : {};
        const Fragment = React.Fragment;
        return (React.createElement("div", { style: Object.assign({}, style), onMouseEnter: () => this.handleHover(true), onMouseLeave: () => this.handleHover(false) },
            React.createElement("div", { style: {
                    display: 'flex',
                    minHeight: 72,
                    position: 'relative',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }, id: `hoverTextInputParent_${field}` },
                children,
                isHovered && (React.createElement(react_responsive_1.default, { minWidth: 1140 }, ReactDOM.createPortal(React.createElement(Fragment, null,
                    React.createElement("div", { style: {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: 0,
                            width: 64,
                        }, onMouseEnter: () => this.handleHover(true), id: `hoverTextBridge_${field}` }),
                    React.createElement("div", { style: {
                            position: 'absolute',
                            top: 0,
                            left: -10,
                            height: 20,
                            width: 20,
                            transform: 'rotate(45deg)',
                            background: src_1.beige,
                            border: `1px solid ${src_1.titanium}`,
                            borderBottom: 'none',
                            borderLeft: 'none',
                            borderRadius: '0 5px 0 0',
                            zIndex: 2,
                        }, id: `hoverTextInputTriangle_${field}` }),
                    React.createElement("div", { style: {
                            position: 'absolute',
                            top: 0,
                            left: 64,
                            width: `calc(100vw - 832px)`,
                        }, id: `hoverTextInputDescriptionChild_${field}` },
                        React.createElement("div", { style: {
                                padding: '16px 12px',
                                minWidth: 370,
                                maxWidth: 556,
                                borderLeft: `4px solid ${src_1.titanium}`,
                            } },
                            React.createElement("div", { style: {
                                    cursor: 'default',
                                    fontFamily: '"Source Sans Pro", sans-serif',
                                    fontSize: 19,
                                    fontWeight: 400,
                                    color: src_1.charcoal,
                                    display: 'inline-block',
                                    lineHeight: '24px',
                                } }, description)))), document.getElementById('mainModalRight')))))));
    }
}
exports.default = HoverTextInput;
